document.addEventListener('alpine:init', () => {
    Alpine.data('bookVisit', (data = {}) => ({
        offers: Array.isArray(data.initialOffers) ? data.initialOffers : [],
        showStatic: Array.isArray(data.initialOffers) && data.initialOffers.length > 0,
        selectedProperties: [],
        selectedCategories: [],
        loading: false,
        filters: { date: '', guests: 2, rooms: 1 },
        availabilityChecked: false,
        activeTab: 0,

        init() {
            if (Array.isArray(data.initialOffers)) {
                if (this.offers.length) this.updateSchema();
            } else {
                this.loading = true;

                fetch(bvAjax.ajax_url + '?action=book_visit_posts')
                    .then(res => res.json())
                    .then(offers => {
                        this.offers = offers || [];
                        this.updateSchema(); // Lägg till schema direkt efter laddning
                    })
                    .catch(e => console.error('Error loading BV offers:', e))
                    .finally(() => this.loading = false);
            }

            this.$watch('filters.date', (val) => {
                this.showStatic = false;
                if (val) {
                    this.checkAvailability();
                } else {
                    this.availabilityChecked = false;
                    this.offers.forEach(o => o.available = undefined);
                    this.updateSchema(); // Uppdatera schema när datum tas bort
                }
            });

            this.$watch('filters.guests', () => {
                if (this.filters.date) this.checkAvailability();
            });

            this.$watch('filters.rooms', () => {
                if (this.filters.date) this.checkAvailability();
            });
        },

        toggleProperty(p) {
            this.showStatic = false;
            const idx = this.selectedProperties.indexOf(p);
            if (idx > -1) this.selectedProperties.splice(idx, 1);
            else this.selectedProperties.push(p);
        },

        toggleCategory(c) {
            this.showStatic = false;
            const idx = this.selectedCategories.indexOf(c);
            if (idx > -1) this.selectedCategories.splice(idx, 1);
            else this.selectedCategories.push(c);
        },

        resetFilters() {
            this.showStatic = false;
            this.filters = { date: '', guests: 2, rooms: 1 };
            this.selectedProperties = [];
            this.selectedCategories = [];
            this.availabilityChecked = false;
            this.offers.forEach(o => o.available = undefined);
            this.updateSchema(); // Uppdatera schema vid reset
        },

        async checkAvailability() {
            if (!this.filters.date) return;
            this.showStatic = false;
            this.loading = true;

            const formData = new FormData();
            formData.append('action', 'book_visit_check_availability');
            formData.append('date', this.filters.date);
            formData.append('guests', parseInt(this.filters.guests));
            formData.append('rooms', parseInt(this.filters.rooms));

            try {
                const res = await fetch(bvAjax.ajax_url, { method: 'POST', body: formData });
                const data = await res.json();
                console.log('BV Availability response:', data);

                if (data.success) {
                    const availableIds = data.data;
                    this.offers = this.offers.map(o => ({
                        ...o,
                        available: availableIds.includes(o.id)
                    }));
                    this.availabilityChecked = true;
                    this.updateSchema(); // Uppdatera schema med korrekt availability
                }
            } catch(e) {
                console.error('BV Availability error:', e);
            } finally {
                this.loading = false;
            }
        },

        get uniqueProperties() {
            return [...new Set(this.offers.map(o => o.property))];
        },

        get uniqueCategories() {
            return [...new Set(this.offers.map(o => o.category))];
        },

        get filteredOffers() {
            return this.offers.filter(o => {
                const propOk = this.selectedProperties.length ? this.selectedProperties.includes(o.property) : true;
                const catOk = this.selectedCategories.length ? this.selectedCategories.includes(o.category) : true;
                const availOk = !this.availabilityChecked || o.available;
                return propOk && catOk && availOk;
            });
        },

        updateSchema() {
            const existingScript = document.getElementById('bv-schema');
            if (existingScript) existingScript.remove();

            const schema = {
                '@context': 'https://schema.org',
                '@type': 'ItemList',
                'itemListElement': this.offers.map((offer, index) => ({
                    '@type': 'ListItem',
                    'position': index + 1,
                    'url': offer.url,
                    'item': {
                        '@type': 'Offer',
                        'name': offer.name,
                        'description': offer.short_description,
                        'image': offer.image,
                        'url': offer.url,
                        'availability': offer.available === undefined
                            ? 'https://schema.org/InStock'
                            : (offer.available ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock'),
                        'priceCurrency': 'SEK'
                    }
                }))
            };

            const scriptTag = document.createElement('script');
            scriptTag.type = 'application/ld+json';
            scriptTag.id = 'bv-schema';
            scriptTag.textContent = JSON.stringify(schema, null, 2);
            document.head.appendChild(scriptTag);
        }
    }));
});

//# sourceMappingURL=book-visit.js.map
